import {
  Box,
  Grid,
  List,
  ListItem,
  ListItemText,
  Typography
} from "@mui/material"
import React from "react"
import {AppButton} from "@app-core/AppButton"

interface EligibilityWelcomeMsgProps {
  onNext: () => void
}

export const EligibilityWelcomeMsg: React.FC<EligibilityWelcomeMsgProps> = (
  props: EligibilityWelcomeMsgProps
) => {
  const {onNext} = props

  const onNextClick = () => {
    onNext()
  }

  return (
    <>
      <Box padding={3}>
        <Grid paddingTop={5} container spacing={2}>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <img src="/assets/images/urospot_doc_patient.png" alt="Article" />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Box sx={{minHeight: "230px"}}>
              <Typography
                className="text-lg"
                fontWeight="bold"
                variant="h4"
                gutterBottom
                component="div"
              >
                This assessment will help determine if you are likely to qualify
                for the Disability Tax Credit.
              </Typography>
              <List dense>
                <ListItem>
                  <ListItemText
                    primary={
                      <Typography
                        className="text-lg"
                        fontWeight="bold"
                        variant="h4"
                        gutterBottom
                        component="div"
                      >
                        Seeing
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary={
                      <Typography
                        className="text-lg"
                        fontWeight="bold"
                        variant="h4"
                        gutterBottom
                        component="div"
                      >
                        Talking
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary={
                      <Typography
                        className="text-lg"
                        fontWeight="bold"
                        variant="h4"
                        gutterBottom
                        component="div"
                      >
                        Hearing
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary={
                      <Typography
                        className="text-lg"
                        fontWeight="bold"
                        variant="h4"
                        gutterBottom
                        component="div"
                      >
                        Walking
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary={
                      <Typography
                        className="text-lg"
                        fontWeight="bold"
                        variant="h4"
                        gutterBottom
                        component="div"
                      >
                        Using the Bathroom
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary={
                      <Typography
                        className="text-lg"
                        fontWeight="bold"
                        variant="h4"
                        gutterBottom
                        component="div"
                      >
                        Eating or Preparing a Meal
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary={
                      <Typography
                        className="text-lg"
                        fontWeight="bold"
                        variant="h4"
                        gutterBottom
                        component="div"
                      >
                        Getting Dressed
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary={
                      <Typography
                        className="text-lg"
                        fontWeight="bold"
                        variant="h4"
                        gutterBottom
                        component="div"
                      >
                        Performing Mental Tasks
                      </Typography>
                    }
                  />
                </ListItem>
              </List>
              <Typography
                className="text-lg"
                fontWeight="bold"
                variant="h4"
                gutterBottom
                component="div"
              >
                The Disability Tax Credit (DTC) is designed to assist people
                with severe and prolonged impairments that exist generally 90%
                of the time even when taking medication, receiving therapy or
                using assistive devices. It also requires that your impairment
                (incontinence in this example) has lasted or is expected to last
                for a minimum of one year.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Box
        display={"flex"}
        alignItems="center"
        justifyContent="flex-end"
        padding={4}
      >
        <AppButton
          onClick={onNextClick}
          sx={{
            backgroundColor: "#000000",
            minWidth: "150px",
            minHeight: "44px"
          }}
          variant="contained"
        >
          Next
        </AppButton>
      </Box>
    </>
  )
}

export default EligibilityWelcomeMsg
